import _ from 'lodash';

const analyticsTypes = {
  CARTS_LIST: 'carts_List',
  CARTS_CART_SHOW: 'carts_Cart_Show',
  CARTS_REFRESH: 'carts_RefreshAll',
  CARTS_PRINT: 'carts_PrintAll',
  CARTS_SWITCH_ACCOUNT: 'carts_Cart_SwitchAccount',
  CARTS_CART_CLEAR: 'carts_Cart_Clear',
  CARTS_CART_REFRESH: 'carts_Cart_Refresh',
  CARTS_CART_ITEM_SWITCH_SUPPLIER_OPEN: 'carts_CartItem_SwitchSupplier_Open',
  CARTS_CART_ITEM_SWITCH_SUPPLIER_DISMISS: 'carts_CartItem_SwitchSupplier_Dismiss',
  CARTS_CART_ITEM_SWITCH_SUPPLIER_CLICK: 'carts_CartItem_SwitchSupplier_Click',
  CARTS_CART_ITEM_REMOVE: 'carts_CartItem_Remove',
  CARTS_CHECKOUT_OFFSITE: 'carts_Cart_CheckoutOffsite_Click',
  CARTS_DIRECT_CHECKOUT_CLICK: 'carts_Cart_DirectCheckout_Click',
  CARTS_REQUISITION_CLICK: 'carts_Cart_Requisition_Click',
  CARTS_CART_SAVE: 'carts_cart_save',
  CARTS_CROSS_SELL_MODAL_OPEN: 'carts_crossSell_Modal_Open',
  CARTS_SCHEDULE_ORDER_CLICK: 'carts_Cart_ScheduleOrder_Click',
};

const extractCartValues = (cart, extra) => ({
  subtotal: _.get(cart, 'summary.subtotal'),
  num_items: _.size(_.get(cart, 'items')),
  status: _.get(cart, 'status'),
  ...extra
});

const extractSupplierValues = (supplier, extra) => ({
  supplier_id: _.get(supplier, 'id'),
  site_status: _.get(supplier, 'site_status'),
  is_vetcove_managed_cart: _.get(supplier, 'are_carts_internally_managed_by_vetcove'),
  supplier_short_name: _.get(supplier, 'short_name'),
  supplier_name: _.get(supplier, 'name'),
  supplier_kind: _.get(supplier, 'kind'),
  ...extra
});

const extractCartItemValues = (cartItem, extra) => ({
  supplier_id: _.get(cartItem, 'supplier'),
  supply_id: _.get(cartItem, 'supply_id'),
  item_id: _.get(cartItem, 'item_id'),
  availability_code: _.get(cartItem, 'availability_code'),
  ...extra
});

const extractCartItemValuesSwitchSuppler = (oldCartItem, newCartItem) => ({
  item_id: _.get(oldCartItem, 'item_id'),
  from_supplier_id: _.get(oldCartItem, 'supplier_id'),
  from_supply_id: _.get(oldCartItem, 'supply_id'),
  from_availability_code: _.get(oldCartItem, 'availability_code'),
  to_supplier_id: _.get(newCartItem, 'supplier_id'),
  to_supply_id: _.get(newCartItem, 'supply_id'),
  to_availability_code: _.get(newCartItem, 'availability_code'),
});

const extractCartSupplierValues = (cart, supplier, extra) => ({
  ...extractCartValues(cart),
  ...extractSupplierValues(supplier),
  ...extra
});

const extractSupplierItemValues = (supplier, item, extra) => ({
  ...extractSupplierValues(supplier),
  ...extractCartItemValues(item),
  ...extra
});

const extractCartCrossSellValues = (supplierId, cartItemsWithSubstitutions, extra) => ({
  supplier_id: supplierId,
  cart_items: _.map(
    cartItemsWithSubstitutions, cartItem => ({
      target_supply_id: _.get(cartItem, 'supply_id'),
      substitute_supply_id: _.get(cartItem, 'substitutable_supply.supply_id'),
      substitute_quantity: _.get(cartItem, 'substitutable_supply.quantity'),
      initiative_code: _.get(cartItem, 'substitutable_supply.initiative_code'),
    })
  ),
  ...extra
});

const analyticsActions = [{
  type: analyticsTypes.CARTS_LIST
}, {
  type: analyticsTypes.CARTS_CART_SHOW,
  attributesExtractor: extractCartSupplierValues
}, {
  type: analyticsTypes.CARTS_REFRESH
}, {
  type: analyticsTypes.CARTS_PRINT
}, {
  type: analyticsTypes.CARTS_SWITCH_ACCOUNT,
  attributesExtractor: extractSupplierValues
}, {
  type: analyticsTypes.CARTS_CART_CLEAR,
  attributesExtractor: extractCartSupplierValues
}, {
  type: analyticsTypes.CARTS_CART_REFRESH,
  attributesExtractor: extractCartSupplierValues
}, {
  type: analyticsTypes.CARTS_CART_ITEM_SWITCH_SUPPLIER_OPEN,
  attributesExtractor: extractCartItemValues
}, {
  type: analyticsTypes.CARTS_CART_ITEM_SWITCH_SUPPLIER_DISMISS,
  attributesExtractor: extractCartItemValues
}, {
  type: analyticsTypes.CARTS_CART_ITEM_SWITCH_SUPPLIER_CLICK,
  attributesExtractor: extractCartItemValuesSwitchSuppler
}, {
  type: analyticsTypes.CARTS_CART_ITEM_REMOVE,
  attributesExtractor: extractSupplierItemValues
}, {
  type: analyticsTypes.CARTS_CHECKOUT_OFFSITE,
  attributesExtractor: extractSupplierValues
}, {
  type: analyticsTypes.CARTS_DIRECT_CHECKOUT_CLICK,
  attributesExtractor: extractCartSupplierValues
}, {
  type: analyticsTypes.CARTS_CART_SAVE
}, {
  type: analyticsTypes.CARTS_REQUISITION_CLICK
}, {
  type: analyticsTypes.CARTS_CROSS_SELL_MODAL_OPEN,
  attributesExtractor: extractCartCrossSellValues
}, {
  type: analyticsTypes.CARTS_SCHEDULE_ORDER_CLICK,
  attributesExtractor: extractCartSupplierValues
}];

export {
  analyticsTypes,
  analyticsActions
};
